const state = {
    list: [
        {
            label: 'Приход',
            value: 0,
        },
        {
            label: 'Расход',
            value: 1,
        }
    ],
    load: false,
};
const mutations = {
};
const actions = {
};
const getters = {
    getById: (state, getters) => id => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.value === id;
        })[0] || {};
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}